export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/gl-logo-abbreviated.54f23e0d.svg","height":24,"width":29};